module.exports = __webpack_public_path__ + "img/aggregate_transport_small.692186c7.svg";